import theme from '../../../lib/theme';

const {
  scale,
  colors
} = theme;

export default () => ({
  section: {
    borderTop: `1px solid ${colors.grey}`,
    marginTop: scale.l,
  },
});
